import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import Draggable from "vuedraggable";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import ParticipantsLoader from "./participants/participants-loader.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import Select2 from "@Shared/components/inputs/select2.vue";
import * as BoardActions from "@Broker/@Modules/clients/board/store/board-actions";
import { useBoardStoreActions } from "@Broker/@Modules/clients/board/store/board-helpers";
import { defineComponent, onMounted, ref, toRefs, computed, watch } from "@vue/composition-api";
import * as referrersAPI from "../../../../clients/referrers/api/referrer-api";
import { REFERRER_TYPE_OPTIONS } from "@Shared/@Utils/constants";
import ReferrersDropdownTemplate from "@Broker/@HandlebarsTemplates/clients/board/table/_referrers-dropdown.hbs";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";
import PhoneInput from "@Shared/components/inputs/phone-input.vue";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "Participants",
  components: {
    CollapsibleCard,
    MaterialInput,
    ParticipantsLoader,
    InlinePrompt,
    Draggable,
    Select2,
    SimpleButton,
    PhoneInput
  },
  mixins: [validationMixin],
  props: {
    clientProfileId: {
      required: true,
      type: String
    },
    boardId: {
      required: true,
      type: String
    }
  },
  validations: {
    newParticipantReferrerDetails: {
      email: {
        email,
        required
      },
      phone: {
        required
      },
      firstName: {
        required
      },
      lastName: {
        required
      }
    }
  },
  setup(props) {
    var _context6;
    const {
      t
    } = useI18n();
    const {
      clientProfileId
    } = toRefs(props);
    const loading = ref(true);
    const editing = ref(false);
    const creating = ref(false);
    const participants = ref([]);
    const allReferrers = ref([]);
    const newParticipantType = ref();
    const newParticipantReferrerID = ref(null);
    const newParticipantReferrerDetails = ref({});
    const {
      GET_CLIENT_PROFILE_PARTICIPANTS,
      ADD_CLIENT_PROFILE_PARTICIPANTS,
      UPDATE_CLIENT_PROFILE_CUSTOM_PARTICIPANT,
      UPDATE_CLIENT_PROFILE_PARTICIPANTS_ORDER,
      DELETE_CLIENT_PROFILE_PARTICIPANTS
    } = useBoardStoreActions([BoardActions.GET_CLIENT_PROFILE_PARTICIPANTS, BoardActions.ADD_CLIENT_PROFILE_PARTICIPANTS, BoardActions.UPDATE_CLIENT_PROFILE_CUSTOM_PARTICIPANT, BoardActions.UPDATE_CLIENT_PROFILE_PARTICIPANTS_ORDER, BoardActions.DELETE_CLIENT_PROFILE_PARTICIPANTS]);
    const loadParticipantsAndReferrers = async () => {
      loading.value = true;
      const [profileParticipants, {
        referrers
      }] = await _Promise.all([GET_CLIENT_PROFILE_PARTICIPANTS({
        clientProfileId: clientProfileId.value
      }), referrersAPI.getAllReferrers({
        searchString: ""
      })]);
      allReferrers.value = _mapInstanceProperty(referrers).call(referrers, r => _objectSpread(_objectSpread({}, r), {}, {
        text: `${r.givenName} ${r.familyName}`
      }));
      participants.value = profileParticipants;
      loading.value = false;
    };
    onMounted(async () => {
      await loadParticipantsAndReferrers();
    });
    watch(() => props.clientProfileId, async () => {
      await loadParticipantsAndReferrers();
    });
    const resetState = () => {
      creating.value = false;
      editing.value = false;
      newParticipantType.value = null;
      newParticipantReferrerID.value = null;
      newParticipantReferrerDetails.value = {};
    };
    const toggleEditing = () => {
      editing.value = !editing.value;
      creating.value = false;
    };
    const toggleCreating = () => {
      creating.value = !creating.value;
      editing.value = false;
    };
    const removeParticipant = async id => {
      loading.value = true;
      await DELETE_CLIENT_PROFILE_PARTICIPANTS({
        clientProfileId: clientProfileId.value,
        participantId: id
      });
      await loadParticipantsAndReferrers();
      resetState();
      loading.value = false;
    };
    const toggleParticipantVisibility = async participant => {
      var _context;
      participants.value = _mapInstanceProperty(_context = participants.value).call(_context, p => p.id === participant.id ? _objectSpread(_objectSpread({}, p), {}, {
        cardVisibility: !p.cardVisibility
      }) : p);
      await UPDATE_CLIENT_PROFILE_CUSTOM_PARTICIPANT({
        clientProfileId: clientProfileId.value,
        participantId: participant.id,
        participantData: {
          cardVisibility: !participant.cardVisibility
        }
      });
    };
    const handleSortEnd = async () => {
      var _context2;
      const participantOrder = _mapInstanceProperty(_context2 = participants.value).call(_context2, p => p.id);
      await UPDATE_CLIENT_PROFILE_PARTICIPANTS_ORDER({
        clientProfileId: clientProfileId.value,
        participantOrder
      });
    };
    const handleNewParticipantTypeChange = selected => {
      if (newParticipantType.value !== selected.id) {
        newParticipantReferrerID.value = null;
        newParticipantReferrerDetails.value = {};
      }
      newParticipantType.value = selected.id;
    };
    const handleNewParticipantReferrerIDChange = selected => {
      newParticipantReferrerID.value = selected.id;
    };
    const handleNewParticipantPhoneChange = phone => {
      newParticipantReferrerDetails.value.phone = phone;
    };
    const referrerTypes = computed(() => {
      var _context3, _context4;
      const mappedTypes = _mapInstanceProperty(_context3 = REFERRER_TYPE_OPTIONS()).call(_context3, opt => ({
        id: opt.id,
        text: opt.text
      }));
      const existingParticipantTypes = _mapInstanceProperty(_context4 = participants.value).call(_context4, p => p.type);
      const typesToUse = _filterInstanceProperty(mappedTypes).call(mappedTypes, type => !_includesInstanceProperty(existingParticipantTypes).call(existingParticipantTypes, type.id));
      if (!_includesInstanceProperty(existingParticipantTypes).call(existingParticipantTypes, "custom")) {
        typesToUse.push({
          id: "custom",
          text: t("client-profile.participants.custom")
        });
      }
      return typesToUse;
    });
    const cardTitle = computed(() => {
      if (editing.value) return t("client-profile.participants.editParticipants");
      if (creating.value) return t("client-profile.participants.addParticipants");
      return t("client-profile.participants.participants");
    });
    const newParticipantReferrerIDOptions = computed(() => {
      const mapReferrerTypeLabel = type => {
        if (!type) return type;
        const translatedType = t(`referrers.referrerType.${type}`).toString();
        return _includesInstanceProperty(translatedType).call(translatedType, "referrers.referrerType.") ? type : translatedType;
      };
      return {
        placeholder: t("client-profile.participants.referrer"),
        templateResult: state => $(ReferrersDropdownTemplate(_objectSpread(_objectSpread({}, state), {}, {
          type: mapReferrerTypeLabel(state == null ? void 0 : state.type)
        })))
      };
    });
    const filteredReferrers = computed(() => {
      var _context5;
      if (!newParticipantType.value) return allReferrers.value;
      return _filterInstanceProperty(_context5 = allReferrers.value).call(_context5, referrer => referrer.type === newParticipantType.value);
    });
    const handleCardCollapsed = () => {
      editing.value = false;
      creating.value = false;
    };
    function isValidEmail(email) {
      if (!email) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    const enableSaveButtonAddParticipant = computed(() => {
      if (!creating.value) return false;
      if (newParticipantType.value === "custom") {
        const details = newParticipantReferrerDetails.value || {};
        return !!details.firstName && !!details.lastName && !!details.phone && !!details.email && isValidEmail(details.email);
      }
      if (newParticipantType.value && newParticipantType.value !== "custom") {
        return !!newParticipantType.value && !!newParticipantReferrerID.value;
      }
      return false;
    });
    const handleAddNewParticipantClick = async () => {
      loading.value = true;
      if (newParticipantType.value == "custom") {
        await ADD_CLIENT_PROFILE_PARTICIPANTS({
          clientProfileId: clientProfileId.value,
          participantData: {
            firstName: newParticipantReferrerDetails.value.firstName,
            lastName: newParticipantReferrerDetails.value.lastName,
            phone: newParticipantReferrerDetails.value.phone,
            email: newParticipantReferrerDetails.value.email
          }
        });
      } else {
        await ADD_CLIENT_PROFILE_PARTICIPANTS({
          clientProfileId: clientProfileId.value,
          participantData: {
            referrerId: _parseInt(newParticipantReferrerID.value)
          }
        });
      }
      resetState();
      await loadParticipantsAndReferrers();
    };
    const handleCancelNewParticipantClick = () => {
      resetState();
    };
    return {
      t,
      participants,
      loading,
      toggleCreating,
      toggleEditing,
      editing,
      creating,
      removeParticipant,
      toggleParticipantVisibility,
      handleSortEnd,
      REFERRER_TYPE_OPTIONS,
      newParticipantType,
      newParticipantReferrerID,
      newParticipantReferrerDetails,
      handleNewParticipantTypeChange,
      handleNewParticipantReferrerIDChange,
      handleNewParticipantPhoneChange,
      referrerTypes,
      cardTitle,
      handleCardCollapsed,
      allReferrers,
      filteredReferrers,
      newParticipantReferrerIDOptions,
      enableSaveButtonAddParticipant,
      handleAddNewParticipantClick,
      handleCancelNewParticipantClick,
      translatedReferrerTypes: _reduceInstanceProperty(_context6 = REFERRER_TYPE_OPTIONS()).call(_context6, (acc, curr) => {
        acc[curr.id] = curr.text;
        return acc;
      }, {})
    };
  }
});